import { render, staticRenderFns } from "./LeccionE4.vue?vue&type=template&id=9deef60e&"
import script from "./LeccionE4.vue?vue&type=script&lang=js&"
export * from "./LeccionE4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports